
const endpoints = {
    getFixedPanelDevices: '/admin/devices/getFixedPanelDevices',
    callToFixedDevice :'/admin/devices/callToFixedDevice'
}

export {endpoints};